import React, {Component} from "react";

import * as Img1 from "./img-1.png";
import * as Img2 from "./img-2.png";
import * as Img3 from "./img-3.png";
import * as Img4 from "./img-4.png";
import * as Img5 from "./img-5.png";
import {ReactComponent as Logo} from "../../img/open-box--order.svg";
import PhotoSlider from '../PhotoSlider';

export default class CreateOrder extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            photoIndex: 0,
            isOpenImgPreview: false,
            images: [Img1, Img2, Img3, Img4, Img5],
        };      
    }

    openPreview = (value, photoIndex) => {
        this.setState({
            isOpenImgPreview: value,
            photoIndex: photoIndex
        });
    };


    render() {
        return (
            <>
                <h1 className="content__title  content__title--icon">
                    <Logo className={"logo_order"}/>
                    <b>оформление заказа <br/>на выкуп</b>
                </h1>
                <div className="content__box">
                    <ol className="numbered-list">
                        <li>
                            <p><b>Открываете интересующую Вас ссылку для выкупа</b> на сайте 1688.com или другом и
                                копируете
                                url
                                в соответствующее поле личного кабинета</p>
                            <p><img src={Img1} onClick={() => this.openPreview(true, 0)}/></p>
                        </li>
                        <li>
                            <p><b>Выбираем необходимую модификацию товара и создаем скриншот или сохраняем снимок
                                экрана.</b>
                            </p>
                            <p>Под модификацией товара мы подразумеваем: цвет, размер, количество товара для выкупа.
                                Иными
                                словами любые характеристики товара.</p>
                            <p>Используйте любые скриншот-сервисы: <ins>joxy</ins>, <ins>prntscrn</ins> и т.д.</p>
                            <p>Если ВЫ не используете подобные сервисы, то воспользуйтесь кнопкой “Print Screen” на
                                клавиатуре +
                                программа Paint для Windows</p>
                            <p><img src={Img2} style={{cursor: 'pointer'}} onClick={() => this.openPreview(true, 1)}/></p>
                        </li>
                        <li>
                            <p><b>Подгрузите сохраненные фотографии</b> с модификациями товара или добавьте скриншот в
                                соответствующее поле</p>
                            <p><img src={Img3} onClick={() => this.openPreview(true, 2)}/></p>
                        </li>
                        <li>
                            <p><b>Укажите суммарную стоимость</b> товара по данной ссылке, <br/>учитывая все модификации
                            </p>
                            <p><img src={Img4} onClick={() => this.openPreview(true, 3)}/></p>
                        </li>
                        <li>
                            <p><b>Укажите дополнительные требования</b> к товарам по данной ссылке или добавьте
                                комментарий,
                                если это необходимо</p>
                            <p><img src={Img5} onClick={() => this.openPreview(true, 4)}/></p>
                        </li>
                    </ol>
                </div>
                {
                    !!this.state.isOpenImgPreview &&
                    <PhotoSlider openPreview={this.openPreview} photoIndex={this.state.photoIndex} images={this.state.images.map(photo => photo)}/>
                }
            </>
        )
    }
}